import React, {useState, useEffect, useRef} from 'react'
import {Card, CardBody, CardHeader} from "reactstrap"
import UsersStaticsDetaileFilters from "./UsersStaticsDetaileFilters"
import {getUsersActionDetail, getExportUsersActionDetail} from "../../../services/api/apiOrdersReport"
import UsersStaticsDetailTable from "./table/UsersStaticsDetailTable"
import moment from "moment"
import {Button} from "antd"
import {CloudUploadOutlined} from '@ant-design/icons'
import UseDebounce from "../../helpers/UseDebounce"
import NextPagination from "../../../components/Pagination/NextPagination"
import queryString from "querystring"
import downloadFile from '../../../share/downloadFile'

function UsersStaticsDetailPage(props) {
    const {location} = props
    let params = {}

    if (location.search !== '') {
        params = queryString.parse(location.search)
    }

    const [filters, setFilters] = useState({
        limit: 50,
        page: 1,
        time_from: moment().format('HH:mm'),
        time_to: moment().format('HH:mm'),
        date_from: moment().subtract(7, 'd').format('DD/MM/YYYY'),
        date_to: moment().format('DD/MM/YYYY'),
        user: params.hasOwnProperty('?user') ? [params['?user']] : []
    })

    const [selectedDate, setSelectedDate] = useState([moment().subtract(7, 'd'), moment()])
    const [reports, setReports] = useState([])
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)

    const debouncedUser = UseDebounce(filters.user, 500)
    const debouncedBarcode = UseDebounce(filters.barcode, 500)
    const debouncedBatch = UseDebounce(filters.batch, 500)
    const debouncedBox = UseDebounce(filters.box, 500)

    const isPaginationClickRef = useRef(false)

    const _handleChangeFilter = (_filters) => {
        isPaginationClickRef.current = false
        setFilters({
            ..._filters,
            page: 1
        })
    }

    const _handleChangeDateSelected = (value) => {
        setSelectedDate(value)
    }

    const _handleChangePage = (page) => {
        isPaginationClickRef.current = true
        setFilters({
            ...filters,
            page: page
        })
    }

    useEffect(() => {
        const _getReportActionsDetail = async () => {
            setLoading(true)
            setReports([])
            setError('')
            if (!isPaginationClickRef.current) {
                setTotal(0)
            }
            try {
                const {action = [], ...restFilters} = Object.assign({}, filters)
                const payload = {
                    ...restFilters,
                }

                if(!!action.length) payload.action = action.join(',')

                if (isPaginationClickRef.current) {
                    payload.withTotal = false
                }
                isPaginationClickRef.current = false

                const {data: respons} = await getUsersActionDetail(payload)
                const {success, data, message} = respons
                if (!success) {
                    setLoading(false)
                    return setError(message)
                }
                const {results, total} = data
                setTotal(prevTotal => (total !== null ? total : prevTotal))
                setReports(results)
            } catch (e) {
                setError(e.message)
            }
            setLoading(false)
        }
        _getReportActionsDetail()
        // eslint-disable-next-line
    }, [filters.sku, filters.action, filters.size, filters.limit, filters.page, filters.date_from, filters.date_to, filters.time_from, filters.time_to, debouncedUser, debouncedBarcode, debouncedBox, debouncedBatch])

    const _exportStaticsUseAction = async () => {
        const {page, limit, action = [], ...restFilters } = Object.assign({}, filters)
        const payload = {
            ...restFilters,
        }

        if (!!action.length) payload.action = action.join(',')
        const { data } = await getExportUsersActionDetail(payload)
        
        downloadFile(data, { filename: `Detailed_log_action-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
    }

    return <div className="UsersStaticsDetailPage">
        <Card>
            <CardHeader className="CardHeader header-elements-inline d-flex align-items-center justify-content-between">
                <h2 className="card-title d-flex align-items-center">
                    Báo cáo chi tiết
                </h2>
                <Button type="primary" icon={<CloudUploadOutlined/>} onClick={_exportStaticsUseAction}>
                    Export data
                </Button>
            </CardHeader>

            <CardBody>
                <UsersStaticsDetaileFilters
                    filters={filters}
                    selectedDate={selectedDate}
                    onChangeSelectedDate={_handleChangeDateSelected}
                    setState={_handleChangeFilter}
                />

                <UsersStaticsDetailTable statics={reports} loading={loading} error={error}/>

                {!loading && <div className="d-flex mt-3 align-items-center justify-content-end">
                    <div className="mr-3">{`Hiển thị ${reports.length} bản ghi trên ${total} bản ghi`}</div>
                    <div className="Pagination">
                        <NextPagination
                            limit={filters.limit}
                            total={total}
                            page={filters.page}
                            onChange={_handleChangePage}
                        />
                    </div>
                </div>}
            </CardBody>
        </Card>
    </div>
}

export default UsersStaticsDetailPage
